import(/* webpackMode: "eager" */ "/app/web/src/app/(auth)/login/page.tsx");
